import * as Exp from './experimentConstants'

const defaultFeatureFlags = {
  // [flagName]: [defaultValue],
  test: false,
  dropshipping_skip_selection: false,
  // tslint:disable-next-line:max-line-length
  ca_bgc_checkr_redirect: false, // Flag for redirect vs no redirect conversion measurement
  dropshipping: false,
  dropshipping_ab: false,
  instant_dashing: false,
  canada_dropshipping_embed_checkr_flow: false,
  dropshipping_status: false,
  enable_i18n_language_selection: false,
  bank_onboarding: false,
  [Exp.RETURN_TO_APPLICATION_AUTO]: false,
  [Exp.DX_CRO_LP_GRADUATION_Q3_2020]: false,
  w9_experiment: false,
  orientation_experiment: false,
  [Exp.INSTANT_DASHING_V2]: false,
  dasher_signup_ui_refresh: false,
  background_check_experiment: false,
  application_status_experiment: false,
  in_app_education_v3: false,
  [Exp.DX_ID_FAST_PAY_Q1_2020]: false,
  [Exp.NEEDS_VEHICLE_INFO]: false,
  [Exp.W_MODEL_EXPERIMENT]: false,
  [Exp.NEEDS_OFFER_LETTER]: false,
  [Exp.DX_PHONE_NUMBER_VERIFICATION]: false,
  [Exp.TOKENIZATION]: false,
  [Exp.DX_WEB_JAPAN_SUPPORT]: false,
  [Exp.DX_PHONE_NUMBER_VERIFICATION_SIGNUP]: false,
  [Exp.NO_W9_EXPERIMENT]: false,
  [Exp.ADDRESS_COLLECTION_AFTER_DASH]: false,
  [Exp.IDENTITY_VERIFICATION]: false,
  [Exp.IDENTITY_VERIFICATION_ANDROID]: false,
  [Exp.BGC_STATUS_UPDATE]: false,
  [Exp.DASHER_WEB_IDENTITY_SERVICE_MIGRATION]: false,
  [Exp.DX_BANK_ACCOUNT_SKIP]: true,
  [Exp.IDV_REFERRAL]: false,
  [Exp.DASHER_PRIVACY_PORTAL]: false,
  [Exp.IDV_SESSION_LIMIT]: false,
  [Exp.DX_ACTIVATED_NO_FIRST_DASH]: false,
  [Exp.DX_ACTIVATED_NO_FIRST_DASH_IOS]: true,
  [Exp.REFERRAL_CODE_REMOVAL]: false,
  [Exp.AUS_NCC_BGC]: false,
  [Exp.GERMANY_DX_ONBOARDING_V2]: false,
  [Exp.JAPAN_DX_ONBOARDING_PLATFORM_MIGRATION]: false,
  [Exp.JAPAN_DX_ENABLE_ORIENTATION]: true,
  [Exp.DX_EXCITEMENT_PROMOTIONS_PAGE]: false,
  [Exp.DX_EXCITEMENT_PROFILE_PAGE]: false,
  [Exp.USE_USER_ME_ENDPOINT]: false,
  [Exp.DX_DRIVERS_LICENSE_TOKENIZATION]: false,
  [Exp.DX_BACKGROUND_CHECK_DESCRIPTION_COPY_V2]: false,
  [Exp.DX_FORM_FOCUS_ENTER_KEY]: false,
  [Exp.DX_ONBOARDING_V2]: false, // feature flag for onbarding (NZ)
  [Exp.DASHER_ONBOARDING_PLATFORM_BFF]: false,
  [Exp.IN_APP_EDUCATION_V4]: false,
  [Exp.DX_USE_V3_API]: false,
  [Exp.SCAN_DL_BACK]: false,
  [Exp.BGC_AUTO_REFRESH]: false,
  [Exp.IDENTITY_LOGIN_BANNER]: false,
  [Exp.BGC_EXTERNAL_LINK]: false,
  [Exp.DX_BGC_ONBOARDING_PLATFORM]: false,
  [Exp.DX_INSTANT_DASHING_NO_ACTIVATION_KIT]: false,
  [Exp.DX_CRO_BGC_NCC_LINK_GRADUATION]: false,
  [Exp.IDENTITY_SIGNUP_MIGRATION]: false,
  [Exp.DX_R2A_DOUBLE_MATCH]: false,
  [Exp.DX_R2A_LOCAL_STORAGE_AUTO_RESUME]: false,
  [Exp.DX_BGC_NCC_CONSUMER_INTEGRATION]: false,
  [Exp.DX_R2A_SKIP_PHONE]: false,
  [Exp.DX_R2A_RECLAIM_EMAIL]: false,
  [Exp.HIDE_FASTPAY_MESSAGE]: false,
  [Exp.HIDE_BANKACCOUNT_HELP]: false,
  [Exp.DX_EXCITEMENT_AUTO_SCROLL]: false,
  [Exp.DX_R2A_SMS_RECLAIM]: false,
  [Exp.DX_BGC_NCC_CHECK_SHARE]: false,
  [Exp.DX_WOLT_JP_TRANSITION]: false,
  [Exp.DX_ONBOARDING_TRACKING_EVENT_MIGRATION]: false,
  [Exp.DX_AU_ABN_REPOSITION]: false,
  [Exp.DX_APP_DASHER_ONBOARDING_REDIRECT]: false,
  [Exp.DX_ADD_BANK_ACCOUNT_FORM_SUBMIT_SEGMENT_EVENT]: false,
  [Exp.IDV_PERSONA_MIGRATION]: false,
}

export default defaultFeatureFlags
